/* eslint-disable */
import { Grid } from '@mui/material';
import React, {
  useEffect, useRef, useState, useCallback,
} from 'react';
import signalFair from '../assets/signalFair.svg';
import signalGood from '../assets/signalGood.svg';
import signalStrong from '../assets/signalStrong.svg';
import signalWeak from '../assets/signalWeak.svg';
import noSignal from '../assets/noSignal.svg';
import { Role, SignalingClient } from 'amazon-kinesis-video-streams-webrtc';
import * as AWS from 'aws-sdk';
import { Hub, PubSub } from 'aws-amplify';
import { getChannelARN, getEndpointsByProtocol, getIceServers } from '../services/kinesis';
import warning from '../assets/warning.svg';
import { getKinesisVideoCreds, subscribeToDeviceChanges } from '../api/UserAPI';
import randomString from '../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { updateVideoInfo } from '../redux/userInfo';
import VideoPlayer from './VideoPlayer';
import { updateDevices } from './Update';

export default function LiveVideoStream(props) {
  let timerId;
  const dispatch = useDispatch();
  const remoteVideoStream = useRef();
  const [loading, setLoading] = useState(false);
  const [, setMessageHistory] = useState('');
  const [, setError] = useState(null);
  const videoInfo = useSelector((state) => state.userInfo.videoInfo);
  const siteOwnerId = useSelector((state) => state.userInfo.ownerId);
  const selectedSiteId = useSelector((state) => state.userInfo.selectedSiteId);
  const numberOfViewers = useRef();
  const rssi = useRef();
  const sd = useRef();
  // viewers subscriptions
  const viewersSubscription = useRef();
  const peerConnectionState = useRef(null);
  const [mqttConnectionRetrySignal, setMqttConnectionRetrySignal] = useState(0);
  const [orientation, setOrientation] = useState('NORMAL');
  const stream = useRef();
  const client = useRef();
  const connection = useRef();
  const channel = useRef();
  const camName = props?.device?.host?.components[0]?.name;
  const isConnected = props?.device?.isConnected;
  const SDRecording = props?.device?.config?.insert?.video?.storage?.local?.mode === 'continuous' 
  ? 'Continuous' : props?.device?.config?.insert?.video?.storage?.local?.mode === 'motion' 
  ? 'Event Only' : 'No SD Detected';

  useEffect(() => {
    setOrientation(props.device?.serverConfig?.video?.orientation);
  }, [props.device]);
  
  useEffect(() => {
    Hub.listen("pubsub", (data) => {
      const { payload } = data;
        if (payload.data.connectionState === 'Disconnected' || payload.data.connectionState === 'ConnectionDisrupted' || payload.data.connectionState === 'ConnectionDisruptedPendingNetwork') {
          setMqttConnectionRetrySignal(mqttConnectionRetrySignal + 1);
        }
    });
    return () => {
      Hub.remove("pubsub");
    };
  }, [props.device, videoInfo]);

  useEffect(() => {
    if (props?.device?.deviceId && selectedSiteId) {
      if (viewersSubscription.current) {
        viewersSubscription.current.unsubscribe();
        viewersSubscription.current = null;
      }
      const subscription = subscribeToDeviceChanges(
        siteOwnerId,
        selectedSiteId,
        props?.device?.deviceId,
        (state) => {
          const { data } = state;
          if (!data) return;
          const { insert } = data;
          if (!insert) return;
          const deviceId = props?.device?.deviceId;
          numberOfViewers.current = insert?.video?.webrtc?.currentViewers;
          rssi.current = data?.connection?.rssi;
          sd.current = insert?.video?.sd?.mem;
          const newObj = {...videoInfo};
          newObj[deviceId] =  { viewers: insert?.video?.webrtc?.currentViewers, rssi: data?.connection?.rssi, sd: insert?.video?.sd?.mem} 
          dispatch(updateVideoInfo(newObj));

        },
        isConnected
      );
      viewersSubscription.current = subscription;
    }
    return () => {
      if (viewersSubscription?.current) {
        viewersSubscription.current.unsubscribe();
        viewersSubscription.current = null;
      }
    }
  }, [selectedSiteId, props.device.deviceId,  mqttConnectionRetrySignal]);

  const closeConnection = () => {
    if (connection.current) {
      connection.current.close();
    }
    if (client.current) {
      client.current.close();
    }
    if (channel.current) {
      channel.current.close();
    }
    peerConnectionState.current = 'closed';
  };

  const addMessageHistory = (message, isOutgoing) => {
    const now = new Date();
    const label = isOutgoing ? 'SENT' : 'RECEIVED';
    const history = `${now.toLocaleTimeString()} ${label} ${message}`;
    setMessageHistory((prev) => `${history}\n${prev}`);
  };

  const initWebRTC = useCallback(async () => {
    if (peerConnectionState.current === 'retry') {
      let interval;
      if(interval) clearTimeout(interval);
      interval = setTimeout(() => {
        peerConnectionState.current = 'new';
      }, 1000);
      clearTimeout(interval);
    }
    if (peerConnectionState.current !=='closed') {
    const { thingName } = props;
    const { isConnected } = props.device;
    const setupSignalingClientListeners = (signalingClient, peerConnection) => {
      signalingClient.on('open', async () => {
        peerConnection.addTransceiver('video', { direction: 'recvonly'} );
        peerConnection.addTransceiver('audio', { direction: 'recvonly'} );
        const offer = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(offer);
        signalingClient.sendSdpOffer(peerConnection.localDescription);
      });

      signalingClient.on('sdpAnswer', async (answer) => {
        await peerConnection.setRemoteDescription(answer);
      });

      signalingClient.on('iceCandidate', (candidate) => {
        peerConnection.addIceCandidate(candidate);
      });

      signalingClient.on('close', () => {
      });

      signalingClient.on('error', (error) => {
        console.error(error);
      });
    };
    const setupPeerConnectionListeners = (peerConnection, signalingClient) => {
      if (peerConnection.connectionState === 'new' && isConnected) {
        peerConnectionState.current = 'new';
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
          if (peerConnectionState.current !== 'closed') {
            peerConnection.onconnectionstatechange = "failed";
            peerConnectionState.current ='retry';
            initWebRTC();
          } else {
            return clearTimeout(timerId);
          }
        }, 30000);
      }
      peerConnection.addEventListener(
        "connectionstatechange",
        (event) => {
          peerConnectionState.current = peerConnection.connectionState;
          switch (peerConnection.connectionState) {
            case "connected":
              clearTimeout(timerId);
              console.log('the timer cleared');
              break;
            case "disconnected":
              console.log("Disconnecting…");
              initWebRTC();
              break;
            case "failed":
              initWebRTC();
              console.log("Error");
              break;
            default:
              break;
          }
        },
        false,
      );
      peerConnection.addEventListener('icecandidate', ({ candidate }) => {
        if (candidate) {
          signalingClient.sendIceCandidate(candidate);
        }
      });

      peerConnection.addEventListener('track', (event) => {
        remoteVideoStream.current.srcObject = event.streams[0];
      });
    };
    if (!isConnected) return;
    if (client.current) {
      client.current.close();
    }
    if (connection.current) {
      connection.current.close();
    }
    if (channel.current) {
      channel.current.close();
    }
    setLoading(true);
    let creds;
    if (props.creds) creds = props.creds;
    else
     creds = await getKinesisVideoCreds(props.device.siteId, props.device.deviceId);
    const kinesisVideo = new AWS.KinesisVideo({
      credentials: {
        accessKeyId: props.creds ? creds.accessKeyId : creds.credentials.accessKeyId,
        secretAccessKey: props.creds ? creds.secretAccessKey : creds.credentials.secretAccessKey,
        sessionToken: props.creds ? creds.sessionToken : creds.credentials.sessionToken,
      },
      region: AWS.config.region ?? 'us-east-1',
    },);
    const channelARN = await getChannelARN(thingName, kinesisVideo);
    const endpointsByProtocol = await getEndpointsByProtocol(
      channelARN,
      kinesisVideo,
      Role.VIEWER,
    );
    const iceServers = await getIceServers(channelARN, endpointsByProtocol, props.device.deviceId, props.creds, props.device.siteId );
    const peerConnection = new RTCPeerConnection({ iceServers });
    peerConnectionState.current = peerConnection.iceConnectionState;
    peerConnection.onconnectionstatechange = (event) => {
    };
    const signalingClient = new SignalingClient({
      channelARN,
      channelEndpoint: endpointsByProtocol.WSS,
      clientId: randomString(8),
      role: Role.VIEWER,
      region: 'us-east-1',
      credentials: {
        accessKeyId: props.creds ? creds.accessKeyId : creds.credentials.accessKeyId,
        secretAccessKey: props.creds ? creds.secretAccessKey : creds.credentials.secretAccessKey,
        sessionToken: props.creds ? creds.sessionToken : creds.credentials.sessionToken,
      },
      systemClockOffset: kinesisVideo.config.systemClockOffset,
    });
    setupSignalingClientListeners(signalingClient, peerConnection);
    setupPeerConnectionListeners(peerConnection, signalingClient);
    client.current = signalingClient;
    connection.current = peerConnection;
    signalingClient.open();
    return () => {
      clearTimeout(timerId);
      signalingClient.removeAllListeners('close');
      peerConnection.onconnectionstatechange = null;
      peerConnection.close();
      signalingClient.close();
    };
  }
  }, [props.thingName, props.device.isConnected]);

  useEffect(() => {
    if (remoteVideoStream.current === null) {
      return;
    }
    if (!stream.current) {
      return;
    }
    remoteVideoStream.current.srcObject = stream.current;
  }, [remoteVideoStream]);

  useEffect(() => () => {
    clearTimeout(timerId);
    if (connection.current) {
      connection.current.close();
    }
  }, [connection]);

  useEffect(() => () => {
    if (client.current) {
      client.current.removeAllListeners('close');
      client.current.close();
    }
  }, [client]);

  useEffect(() => () => {
    if (channel.current) {
      channel.current.onclose = null;
      channel.current.close();
    }
  }, [channel]);

  useEffect(() => {
    initWebRTC();
  }, [initWebRTC]);

useEffect(() => {
  const interval = setInterval(async () => {
      await updateDevices(dispatch, selectedSiteId);
  }, 30000);
  return () => clearInterval(interval);
}, []);

const setText = (connectionState) => {
  let message;
  switch (connectionState) {
    case 'new' :
      message = 'Step 1 of 3:  Establishing a secure connection';
      break;
    case 'connecting':
      message = 'Step 2 of 3:  Authenticating camera';
      break;
    case 'connected':
      message = 'Step 3 of 3:  Loading video stream';
      break;
    default:
      message = '';
  }
  return (
    <div className='video-stream-message'>
      <span>{message}</span>
      <span className="loader" />
    </div>
  )
}

const retryConnection = ()  => {
  peerConnectionState.current = 'retry';
  initWebRTC();
}

  const getVideoBtnWrapper = () => {
    if (isConnected && ['disconnected', 'failed', 'closed'].includes(peerConnectionState.current)) {
      return (
        <>
          <span className='white'>
            {peerConnectionState.current.charAt(0).toUpperCase() + peerConnectionState.current.slice(1)}
            ...
          </span>
          <button className="text-btn" onClick={retryConnection}>Retry</button>
        </>
      );
    } if (isConnected && ['new', 'connecting'].includes(peerConnectionState.current)) {
      return (
        <div>
          <span>{setText(peerConnectionState.current)}</span>
          <div className="connection-buttons">
            <button className="text-btn" onClick={closeConnection}>Cancel</button>
            <button className="text-btn" onClick={retryConnection}>Retry</button>
          </div>
        </div>
      );
    }
    if (isConnected && peerConnectionState.current === 'retry') {
      return (
        <span className="loader" />
      )
    }
    return null;
  };

  const getRSSIIcon = () => {
    let img;
    switch (true) {
      case rssi.current < -110:
        img = <img src={noSignal} className='signal-img'/>;
        break;
      case rssi.current >= -110  && rssi.current < -100 :
        img = <img src={signalWeak} className='signal-img'/>;
        break;
      case rssi.current >= -100  && rssi.current <= -86 :
        img = <img src={signalFair} className='signal-img'/>;
        break;
      case rssi.current >= -85 && rssi.current < -70 :
        img = <img src={signalGood}className='signal-img'/>;
        break;
      case rssi.current >= -70: 
        img = <img src={signalStrong} className='signal-img'/>;
        break;
      default: 
        img =<img src={noSignal} className='signal-img'/>

    }
    return img;
  };

  const getMemeory = () => {
    const mem = isNaN(sd.current?.total) ? 0 : Math.round(sd.current?.total /Math.pow(10, 6));
    const roundedMem = Math.pow(2,Math.ceil(Math.log(mem)/Math.log(2)));
    return `${roundedMem} GB`;
  }

  return (
    <Grid item xs={6}>
      <div className="container">
      {isConnected
        ? (
      <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ display: 'inline-block' }}>{camName}</h3>
        {peerConnectionState.current === 'connected' && <button className="text-btn primary" style={{ marginLeft: '8px' }} onClick={closeConnection}>[X]</button>}
      </div>
        )
        :  (
          <h3 className="cam-name">
            <img src={warning} alt="disconnected" className="icon-filter-yellow" />
            {camName}
            {' '}
            - Offline
          </h3>
        )}
        <VideoPlayer orientation={orientation} ref={remoteVideoStream} isConnected={isConnected} peerConnection={peerConnectionState.current} />

        <div className="video-btn-wrapper">
          {getVideoBtnWrapper()}
        </div>
      </div>

      {/* Name of insert chosen by user */}
      {isConnected && props.showInfo
        ? (
          <div className='video-info'>
            <div >
              <h5 className='black'><b>Viewers: </b>{`${numberOfViewers.current ?? 0}`}</h5>
              <h5 className='black'><b>RSSI: </b>{`${rssi.current ?? ''} `}{getRSSIIcon()}</h5>
            </div>
            <div>
              <h5 className='black'><b>SD Recording: </b>{` ${SDRecording}`}</h5>
              <h5 className='black'><b>Total Memory: </b>{getMemeory()}</h5>
            </div>
          </div>
        )
        : null }
    </Grid>
  );
}